export const PHONE_MASK = '(###) ###-##-##'

export function normalizePhoneDigits(value) {
  let digits = String(value || '').replace(/\D/g, '')

  if (digits.length > 0 && (digits[0] === '7' || digits[0] === '8')) {
    digits = digits.slice(1)
  }

  return digits.slice(0, 10)
}

export function formatPhoneForApi(digits) {
  return `+7${digits}`
}

export function isValidPhoneDigits(digits) {
  return /^\d{10}$/.test(digits)
}
